import { type ILabelActions } from '@cx-web/feature-i18n';

import styles from './MyOCLogin2018.module.css';
import { type MyOCLogin2018View } from './types';

interface ImageSectionProps {
  labelActions: ILabelActions;
  /** Base URL the brand artwork (banner + logo + tick) is served from (`${resourcesUrl}/assets/img/`). */
  resourcesUrl: string;
  view: MyOCLogin2018View;
}

/**
 * Hero panel ported from the legacy widget's `image-section` (the left half of the desktop modal): a
 * mirrored athlete photo under a navy gradient with the white Oddschecker logo, plus a sign-up reasons
 * list shown only on the signup view. Hidden below 600px (the form takes the full width on mobile).
 *
 * The legacy `scaleX(-1)` on the panel + a second `scaleX(-1)` on the inner overlay are preserved: the
 * background photo is mirrored while the logo/text stay upright, matching the legacy look.
 */
const ImageSection: React.FC<ImageSectionProps> = ({ labelActions, resourcesUrl, view }) => {
  const reasons = [
    labelActions.get('AUTH_AI_DRIVEN_TOOLS'),
    labelActions.get('AUTH_SPORTSBOOK_COMPARISONS'),
    labelActions.get('AUTH_EXPERT_PICKS'),
  ];

  return (
    <div className={styles.imageSection} data-testid="myoc-auth-image-section">
      <div
        className={styles.image}
        style={{ backgroundImage: `url(${resourcesUrl}/assets/img/myoc-login-banner.webp)` }}
      >
        <div className={styles.imageOverlay}>
          {view === 'signup' && (
            <div className={styles.onboarding}>
              <div className={styles.onboardingTitle}>{labelActions.get('AUTH_NEW_SIGN_UP_REASONS')}</div>
              <div className={`${styles.onboardingTitle} ${styles.onboardingTitleHighlight}`}>
                {labelActions.get('AUTH_SIGN_UP')}
              </div>
              <ul className={styles.onboardingList}>
                {reasons.map((reason, index) => (
                  <li key={index}>
                    <img
                      alt=""
                      className={styles.onboardingTick}
                      src={`${resourcesUrl}/assets/img/myoc-login-tick.svg`}
                    />
                    <span>{reason}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <img alt="Oddschecker" className={styles.imageLogo} src={`${resourcesUrl}/assets/img/OC_LOGO_2.webp`} />
        </div>
      </div>
    </div>
  );
};

export default ImageSection;
